import { RadioGroup } from "@headlessui/react";
import styles from "./RadioControl.module.scss";
import classNames from "classnames";
import RadioControlOption, {
  RadioControlOptionProps,
} from "./RadioControlOption";
import ProductIcons from "icons/products";

const RadioControl = (
  {
    value,
    onChange,
    options,
    label,
    onClick = () => {},
    className = "",
    optionClassName = "",
  },
) => {
  return (
    <RadioGroup
      value={value}
      onChange={onChange}
      className={classNames(styles.root, className)}
    >
      {label && (
        <RadioGroup.Label className={styles.label}>{label}</RadioGroup.Label>
      )}
      {options.map((option: RadioControlOptionProps) => (
        <RadioGroup.Option
          key={option.value}
          onClick={() => onClick(option.value)}
          value={option.value}
          className={classNames(styles.option, optionClassName)}
        >
          {({ checked }) => <RadioControlOption {...{ ...option }} />}
        </RadioGroup.Option>
      ))}
    </RadioGroup>
  );
};

export default RadioControl;
